var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-overlay',_vm._g(_vm._b({},'v-overlay',_vm.$attrs,false),_vm.inputListeners),[_c('v-progress-circular',{attrs:{"indeterminate":"","size":"64"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }